import React, { useState, useTransition } from 'react';
import '../styles/navbar.css';
import logo from '../assets/imgs/navbar.png';
import { useHref, useLinkClickHandler } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function TransitionLink({ to, children, ...rest }) {
  let href = useHref(to);
  let linkClickHandler = useLinkClickHandler(to);
  let [_, startTransition] = useTransition();

  const handleClick = (event) => {
    startTransition(() => {
      linkClickHandler(event);
    });
  };

  return (
    <a
      {...rest}
      href={href}
      onClick={handleClick}
    >
      {children}
    </a>
  );
}

function Navbar() {
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);
  const { t, i18n } = useTranslation('navbar');

  const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang); // Changes the language
  };

  return (
    <div className="pos-f-t">
      <div className={isNavCollapsed ? 'collapse' : 'collapse show'} id="navbarToggleExternalContent">
        <div className="bg-dark p-4">
          <nav className="nav flex-column">
            <TransitionLink to="/proyectos" className="nav-link active text-white">{t('projects')}</TransitionLink>
            <TransitionLink to="/grupos" className="nav-link text-white">{t('groups')}</TransitionLink>
            <TransitionLink to="/equipo" className="nav-link text-white">{t('team')}</TransitionLink>
            <TransitionLink to="/personas" className="nav-link text-white">{t('people')}</TransitionLink>
          </nav>
        </div>
      </div>
      <nav className="navbar navbar-dark bg-dark">
        <button
          className="navbar-toggler d-lg-none"
          type="button"
          onClick={handleNavCollapse}
          aria-controls="navbarToggleExternalContent"
          aria-expanded={!isNavCollapsed}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <TransitionLink to="/" className="navbar-brand"><img src={logo} alt="Logo" className="navbar-logo" /></TransitionLink>
        <div className="navbar-links d-none d-lg-flex ml-auto">
          <TransitionLink to="/proyectos" className="nav-link">{t('projects')}</TransitionLink>
          <TransitionLink to="/grupos" className="nav-link">{t('groups')}</TransitionLink>
          <TransitionLink to="/equipo" className="nav-link">{t('team')}</TransitionLink>
          <TransitionLink to="/personas" className="nav-link">{t('people')}</TransitionLink>
        </div>
        <div className="navbar-language">
          <select onChange={(e) => changeLanguage(e.target.value)} className="language-select">
            <option value="en">English</option>
            <option value="es">Español</option>
          </select>
        </div>
      </nav>
    </div>
  );
}


//<a className="nav-link text-white" href="/eventos">Eventos</a>

//<a href="/eventos" className="nav-link">Eventos</a>

export default Navbar;
